import {Injectable} from "@angular/core";
import {ApplicationProjectTypeActions} from "../Actions/application-project-types-actions";
import {ApplicationUserInfoActions} from "../Actions/application-user-info-actions";
import {IeDsFile, IeDsFileSystem, IeDsFolder} from "../../models/user-info";
import {tassign, Utils} from "../../common/utils";
import {isNullOrUndefined} from "util";
import {EMPTY, from, of} from "rxjs";
import {catchError, filter, map, mergeMap, tap} from "rxjs/operators";
import {ActionLocal} from "../Actions/actions.service";
import * as R from "ramda";
import {AuthService} from "../../auth/auth.service";
import {ofType} from "redux-observable";
import {edsEnvConfiguration} from "../../../environments/edsEnvConfiguration";
import {getContextAndParamUrl} from "../../models/utils_specs";
import {HeaderComponent} from "../../components/header/header.component";
import {ISelectorState} from "../selector.state";

@Injectable()
export class LoadUserInfoEpics {
  constructor(private httpAuth: AuthService) {
  }

  private getLoginUrl(s: ISelectorState) {
    /*
      @select(['appSpec', 'spec', 'value']) specs$: Observable<ISpec<number>>;
      @select(['appCatalog', 'name']) catalog$: Observable<string>;
      @select(['appToolBar', 'search']) searchField$;
      @select(['appCatalog', 'selectedSolution']) selectedSolution$: Observable<Ic>;

    * */
    const contextToLoad = Utils.getFieldValue(HeaderComponent.catalogToContextMap, s.appCatalog.name);
    if (contextToLoad) {
      const paramStr = getContextAndParamUrl(contextToLoad, s.appSpec.spec.value, s.appToolBar.search, s.appCatalog.selectedSolution ? s.appCatalog.selectedSolution.key : null);
      const url = document.location.href.replace(/#.*$/, "") + "#/widget/param?" + paramStr;
      return url;
    }

    return document.location.href;
  }

  private flatFileSystemTree(obj: IeDsFileSystem): IeDsFile[] {
    let files: IeDsFile[] = [];
    // console.log("Read FS ", obj);
    if (Utils.getFieldValue(obj, 'folder.label')) {     // only one folder
      files = this.flatFolder(obj.folder as IeDsFolder);
    } else {
      files = (obj.folder as IeDsFolder[]).reduce((acc: IeDsFile[], val: IeDsFolder) => acc.concat(this.flatFolder(val)), []);
    }
    return files;
  }

  private flatFolder(dir: IeDsFolder, parentFolder: string = ''): IeDsFile[] {
    let files: IeDsFile[] = [];
    // console.log("Sub folder parent:",parentFolder, " :", dir);
    if (!isNullOrUndefined(dir) && !isNullOrUndefined(dir.folder)) {
      if (Utils.getFieldValue(dir, 'folder.label')) {     // only one folder
        files = this.flatFolder(dir.folder as IeDsFolder, dir.label);
      } else {
        files = (dir.folder as IeDsFolder[]).reduce((acc: IeDsFile[], val: IeDsFolder) => acc.concat(this.flatFolder(val, dir.label)), []);
      }
    }
    if (!isNullOrUndefined(dir.file)) {
      files = files.concat(dir.file);
    }

    return files.map(f => tassign(f, {path: (!isNullOrUndefined(parentFolder) ? parentFolder : '') + '/' + (!isNullOrUndefined(f.path) ? f.path : dir.label)}));
  }

  private updateFolderTree(tree: IeDsFolder): IeDsFolder[] {
    const checkFile = x => R.ifElse(R.has('file'), R.over(R.lensProp('file'), updateFile), R.identity)(x);
    const checkFolder = x => R.ifElse(R.has('folder'), R.over(R.lensProp('folder'), updateFolder), R.identity)(x);
    const addProp = R.assoc('isFolder', true);
    const updateFolderItem = x => R.compose(addProp, checkFolder, checkFile)(x);
    const updateFileItem = x => ({...x, isFolder: false});
    const updateFile = (node) => (Array.isArray(node) ? node.map(x => updateFileItem(x)) : updateFileItem(node));
    const updateFolder = (node) => (Array.isArray(node) ? node.map(x => updateFolderItem(x)) : updateFolderItem(node));
    return updateFolder(tree);
  }

  // ApplicationUserInfoActions.ActionType.LOGIN_USER
  loginUser = (action$, store) => {
    return action$.pipe(
      ofType(ApplicationUserInfoActions.ActionType.LOGIN_USER),
      mergeMap(() => {
        // payload will be the redirect url
        const _loginURL = edsEnvConfiguration.login_url + this.getLoginUrl(store.value);
        window.open(_loginURL, '_self');       // ask login user and redirect to this page again
        return EMPTY;
      })
    );
  }

  loadUserLogged = (action$) => {
    return action$.pipe(
      ofType(ApplicationUserInfoActions.ActionType.LOAD_USER_LOGGED),
      mergeMap(() => {
        return this.httpAuth.userInfo().pipe(
          map(usr => ApplicationUserInfoActions.setUser(usr)),
          catchError((error: Response) => of(ApplicationUserInfoActions.setUser(null)))
        );
      })
    );
  }

  loadingUserData = (action$) => {
    const listeningAction: string[] = [
      ApplicationUserInfoActions.ActionType.LOAD_FILE_SYSTEMS,
      ApplicationUserInfoActions.ActionType.SET_USER
    ];
    return action$.pipe(
      filter((x: ActionLocal) => listeningAction.includes(x.type)),
      map( _ => ApplicationUserInfoActions.loadingUserData() )
    );
  }

  loadUserFile = (action$) => {
    return action$.pipe(
      ofType(ApplicationUserInfoActions.ActionType.LOADING_USER_DATA),
      mergeMap(() => {
        return this.httpAuth.userFiles().pipe(
          map(userTree => (ApplicationUserInfoActions.setUserProjects(this.updateFolderTree(userTree)))),
          catchError((error: Response) => of(ApplicationUserInfoActions.setUserProjects([])))
        );
      })
    );
  }


  setCurrentFolders = (action$) => {
    const listeningAction: string[] = [
      ApplicationUserInfoActions.ActionType.SET_EXAMPLE_PROJECTS,
      ApplicationUserInfoActions.ActionType.SET_USER_PROJECTS,
    ];
    return action$.pipe(
      filter((x: ActionLocal) => listeningAction.includes(x.type)),
      mergeMap(() => from([
        ApplicationUserInfoActions.setCurrentUserFolder(null),
        ApplicationUserInfoActions.setCurrentExampleFolder(null)
      ]))
    );
  }

  loadUserDataCompleted = (action$) => {
    return action$.pipe(
      ofType(ApplicationUserInfoActions.ActionType.SET_CURRENT_USER_FOLDER),
      map( _ => ApplicationUserInfoActions.loadUserDataCompleted() )
    );
  }


  // loadExampleFile = (action$) => {
  //   const listeningAction: string[] = [
  //     ApplicationUserInfoActions.ActionType.LOAD_FILE_SYSTEMS,
  //     ApplicationProjectTypeActions.ActionType.LOADED
  //   ];
  //   return action$.pipe(
  //     filter((x: ActionLocal) => listeningAction.includes(x.type)),
  //     mergeMap(() => {
  //       return XmlUtils.loadXmlFile(this.http, edsEnvConfiguration.examplesPrj).pipe(
  //         map((exampleTree: IeDsFolder) => (ApplicationUserInfoActions.setExampleProjects(this.updateFolderTree(exampleTree)))),
  //         catchError((error: Response) => of(ApplicationUserInfoActions.setExampleProjects([])))
  //       );
  //     })
  //   );
  // }

}
